import React, { useEffect, useState } from "react";
import BarChart from "../../Charts/BarChart";
import ScatterPlot from "../../Charts/ScatterPlot";
import "./Overview.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import NewUsersBox from "../../Charts/NewUsersBox";
import NewTicketBox from "../../Charts/NewTicketBox";
import RevenueBox from "../../Charts/RevenueBox";
import TrafficBox from "../../Charts/TrafficBox";
import LineChart from "../../Charts/LineChart";
import GeoMap from "../../Charts/GeoMap";
import axios from "axios";
import LoadingScreen from "../../../LoadingScreen";

const Overview = () => {

  const [loading,setLoading] = useState(true);
    const [orgStats,setOrgStats] = useState(null)

    const getAdminStats = async (id) => {
      try {
        const response = await axios.get(`https://event-finder12.onrender.com/data/adminData`)
        setOrgStats(response.data);
        setLoading(false);
        console.log(response.data)
      } catch (err) {
        console.log(err);
      }
  }


    useEffect(()=> {
      getAdminStats();
    },[]);





  return (
    <div>
      {loading ? <LoadingScreen/> : (<>
           <div className="small-details-divs">
           <div className="small-detail">
                 <RevenueBox revenue={orgStats.revenue}/>
             </div>
             <div className="small-detail margin-right">
                 <NewUsersBox users={orgStats.usersData}/>
             </div>
             <div className="small-detail">
                 <NewTicketBox tickets={orgStats.ticketData}/>
             </div>
             <div className="small-detail">
                 <TrafficBox traffic={orgStats.trafficData}/>
             </div>
           </div>
           <div className="first-row-charts">
             <div className="first-row-chart">
               <BarChart salesByCat = {orgStats.salesByEventCategory}/>
             </div>
             <div className="first-row-chart">
               {" "}
               <ScatterPlot />
             </div>
           </div>
           <div className="first-row-charts">
             <div className="first-row-chart line-graph">
               <LineChart trend= {orgStats.ticketSalesByHour}/>
             </div>
             <div className="first-row-chart map-div">
               {" "}
               <GeoMap geoData={orgStats.ticketsByCountry}/>
             </div>
           </div>
           </>
      )}
    </div>
  );
};

export default Overview;
